import { i18nService } from '@zonofi/i18n';
import { BannerData } from '@zonofi/common';

export const getMessageBannerData = (): BannerData => ({
  impression: {
    displayText: i18nService.t('chats:IMPRESSION'),
    icon: 'Impression',
    color: '#164B68',
  },
  engaged: {
    displayText: i18nService.t('chats:ENGAGED'),
    icon: 'Engaged',
    color: '#3F1B73',
  },
  order_draft: {
    displayText: i18nService.t('chats:ORDERED_DRAFT'),
    icon: 'Ordered',
    color: '#135439',
  },
  order_submitted: {
    displayText: i18nService.t('chats:ORDERED_SUBMITTED'),
    icon: 'Ordered',
    color: '#135439',
  },
  order_approved: {
    displayText: i18nService.t('chats:ORDERED_ACCEPTED'),
    icon: 'Ordered',
    color: '#135439',
  },
});
